import { useState, useEffect } from "react";
import { getContent } from "../services/exploreService";

/**
 * Hook to fetch all content
 */
export const useContent = () => {
    const [content, setContent] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const data = await getContent();
                setContent(data);
            } catch (err) {
                setError(err.message || "Failed to fetch content");
            } finally {
                setLoading(false);
            }
        };
        fetchContent();
    }, []);

    return { content, loading, error };
};
